import dayjs from "dayjs";

export function sortByDate<T extends { date: string }>(values: T[]) {
  return values.sort((v1, v2) => dayjs(v2?.date).diff(dayjs(v1?.date)));
}

export function groupByDate<T extends { date: string }>(values: T[]) {
  const dateGroups: { date: string; values: T[] }[] = [];
  values.forEach((value) => {
    const dateString = dayjs(value?.date).format("YYYY-MM-DD");
    let dateGroup = dateGroups.find((dg) => dg.date === dateString);
    if (!dateGroup) {
      dateGroup = { date: dateString, values: [] };
      dateGroups.push(dateGroup);
    }
    dateGroup.values.push(value);
  });
  return dateGroups;
}

export function sortAndGroupByDate<T extends { date: string }>(
  values: T[]
): { date: string; values: T[] }[] {
  return groupByDate(sortByDate(values));
}
